import { Subject } from "rxjs";
import { log2 } from "./log2";

const messages = new Subject();
const log = log2("PUB_SUB");
export const SystemMessageTypes = {
    TAB_VISIBILITY_CHANGE: "tab_visibility_change",
    OPEN_CHAT: "open_chat",
    FOCUS_CHAT: "focus_chat",
    OPEN_TEAM_CHAT: "open_team_chat",
    INVOICE_CREATED: "invoice-created",
    CONNECT_SUPPORT_TEAM: "connect-support-team",
    SW_REGISTERED: "sw-registered",
    NOTIFICATION_GRANTED: "notification-granted",
    ACTIVE_CONVERSATION_CHANGED: "active-conversation-changed",
    ACTIVE_CONVERSATION_LOAD_MORE: "active-conversation-load-more",
    TEAM_CONVERSATION_LOAD_MORE: "team-conversation-load-more",
    CB_FOCUS_BLOCK: "cb-focus-block",
    CB_SELECT_BLOCK: "cb-select-block",
    CB_ATTRIBUTE_CHANGED: "cb-attribute-changed",
    CB_SHOW_ATTRIBUTE_MODAL: "cb-show-attribute-modal",
    CB_CHAT_WIDGET_OPEN_STATE_CHANGED: "cb-chat-widget-open-state-changed",
    CB_GET_CUSTOM_ATTRIBUTES: "cb-get-custom-attributes",
    CB_GET_CUSTOM_ATTRIBUTES_RESPONSE: "cb-get-custom-attributes-response",
    CB_BUTTON_CLICK: "cb-button-click",
    START_AGENT_CHAT: "start-agent-chat",
    SETTINGS_PAGE_CHANGED: "settings_page_changed",
    NOTIFICATION_SETTINGS: "notification_settings",
    START_SCRAPE_WEBSITE: "scrape_website",
    ACTIVE_VOICE_ASSISTANT: "active_voice_assistant",
    NOTIFICATION_UPDATED: "notification_updated",
    AUTOMATION_CLOSE_TOOLBAR: "AUTOMATION_CLOSE_TOOLBAR",
    SUPER_MENU_ACTION_SELECTED: "SUPER_MENU_ACTION_SELECTED",
    SUPER_MENU_CLOSED: "SUPER_MENU_CLOSED",
    START_CHAT: "start_chat",
    APPLY_FILTER_TEMPLATE: "apply_filter_template",
    VOICE_COMMAND_RECEIVED: "voice_command_received",
    VOICE_ASSISTANT_RESPONSE_RECEIVED: "voice_assistant_response_received",
    SHOULD_SELECT_PLAN: "should_select_plan",
    SHOULD_PAYMENTS: "should_payments",
    SHOW_SINGLE_GUIDE_TOUR: "show_single_guide_tour", //for single guide tour
    TOUR_ACTION_PERFORMED: "tour_action_performed", //for single guide tour

    // TABLE CONTACT
    TABLE_CONTACT_ACTION: "table_contact_action",

    // TASK CRUD
    TASK_CREATED: "task_created",
    TASK_UPDATED: "task_updated",
    TASK_DELETED: "task_deleted",
    TASK_MOVED_BOARD: "task_move_board",
    TASK_UNARCHIVED: "task_unarchived",
    TASK_DONE: "task_done",
    
    // WEBPHONE
    WEBPHONE_CALL_START: "webphone_call_start",
    
    // AI VOICE AGENT
    AI_VOICE_CALL_START: "ai_voice_call_start",

    // WIDGET
    OPEN_WIDGET: "open_widget",

    // CONTACT
    CONTACT_REMOVED_FROM_LIST: "contact_removed_from_list",
    
    // BROADCAST
    BROADCAST_CREATED: "broadcast_created",
    BROADCAST_STATUS_CHANGED: "broadcast_status_changed",
};
export const publishMessage = (type, payload) => {
    // log("publishMessage", { type, payload });
    messages.next({
        type,
        payload,
    });
};

export const systemMessageStream = messages.asObservable();

document.addEventListener("visibilitychange", () => {
    publishMessage(SystemMessageTypes.TAB_VISIBILITY_CHANGE, {
        visible: document.visibilityState === "visible",
    });
});

const SYSTEM_PUBSUB = {
    stream: systemMessageStream,
    publish: publishMessage,
    MESSAGE_TYPES: SystemMessageTypes,
};
export default SYSTEM_PUBSUB;
